import { twMerge } from "tailwind-merge"

export function ColorSwatch({
  color,
  width = 20,
  className,
  ...props
}: {
  color: string
  width?: number
  className?: string
  [key: string]: any
}) {
  return (
    <div
      className={twMerge("flex items-center justify-center", className)}
      style={{
        width: `${width}px`,
        height: `${width}px`,
        backgroundColor: color,
        border: `1px solid ${color}`,
        overflow: "hidden",
        borderRadius: `calc(${width}px / 3)`,
        flexShrink: 0,
      }}
      {...props}
    />
  )
}
